<!-- 帮助文档 -->
<template>
    <div class='page_content'>


        <div class="page_content_top">
            <el-cascader style="width: 100%;" ref="searchInput" @change="setSearchValue" v-model="searchValue" clearable
                placeholder="试试搜索：采购" :props="{ expandTrigger: 'hover', emitPath: true }" :options="searchData"
                filterable></el-cascader>

        </div>
        <div class="page_content_center">
            <quill-editor v-model="helpValue" ref="myQuillEditor" :style="{height: boxHeight}" :options="editorOption" @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)" @change="onEditorChange($event)" class="myquillEditor"></quill-editor>
        </div>
        <div class="foot">
            <div>
                <el-button type="primary" @click="claerValue()">
                    重置</el-button>
                    <el-button type="primary" @click="saveOrUpdate()">
                    保存</el-button>
            </div>
        </div>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
    },
    data() {
        //这里存放数据
        return {
            searchValue: "",
            searchData: [],
            helpValue: '',
            isLoaded: false,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'font': [] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            // ['clean'], 
                            // ['link', 'image'] 
                        ],
                        handlers: {
                            'image': function (value) {
                                if (value) {
                                    document.querySelector('.edit-uploader input').click()
                                } else {
                                    this.quill.format('image', false);
                                }
                                // this.$refs.aUpload.click() //自定义图片上传回调 
                            }
                        }
                    },
                    syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                    }
                }
            },
            quill: {},
            quillUpdateImg: "",
            boxHeight: '500px',
            jurId: ''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        claerValue() {
            this.helpValue = ''
        },
        sendDataAction() {
            console.log(this.helpValue)
        },
        // 富文本编辑方法 
        onEditorReady(editor) { // 准备编辑器 
        },
        onEditorBlur() { }, // 失去焦点事件 
        onEditorFocus() { }, // 获得焦点事件 
        onEditorChange() { }, // 内容改变事件 
        beforeEditorUpload() {
            // 显示loading动画 
            this.quillUpdateImg = true
        },
        editorUploadSuccess(res, file) {
            // 获取富文本组件实例 
            let quill = this.$refs.myQuillEditor.quill
            // 如果上传成功 
            if (res.code === 0) {
                // 获取光标所在位置 
                let length = quill.getSelection().index;
                // 插入图片  res.info为服务器返回的图片地址 
                quill.insertEmbed(length, 'image', res.data.filepath)
                // 调整光标到最后 
                quill.setSelection(length + 1)
            } else {
                this.$message.error('图片插入失败')
            }
            // loading动画消失 
            this.quillUpdateImg = false
        },

        // 富文本图片上传失败 
        editorUploadError() {
            // loading动画消失 
            this.quillUpdateImg = false
            this.$message.error('图片插入失败')
        },
        setSearchValue() {
            console.log(this.searchValue)
            this.jurId = this.searchValue[this.searchValue.length - 1]
            this.getDocument()
        },
        // 获取权限
        async getJurisdictionList() {
            var dataInfo = this.$store.getters.getUserInfo;
            let responseData = await this.$http.getUserJurisdiction({
                jurType: 0, //	权限类型权限类型0.erp1.协同
                opmId: dataInfo.opmId, //	id列表
            })
            if (responseData && responseData.status == 200) {
                this.searchData = this.handleJurisdictionTwo(responseData.result);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdictionTwo(data, id = 0, lev = 0) {
            var son = [];
            data.forEach((value, keys) => {
                if (lev <= 2) {
                    if (value["jurParentid"] == id) {
                        value["value"] = value["jurId"];
                        value["label"] = value["jurName"];
                        value["lev"] = lev;
                        var list = this.handleJurisdictionTwo(
                            data,
                            value["jurId"],
                            lev + 1
                        );
                        if (list.length >= 1) {
                            value["children"] = this.handleJurisdictionTwo(
                                data,
                                value["jurId"],
                                lev + 1
                            );
                        }
                        son.push(value);
                    }
                }
            });
            return son;
        },
        // 根据id查询文档内容
        async getDocument() {
            let params = {
                ids: [this.jurId]
            }
            var responseData = await this.$http.getDocumentData(params)
            if (responseData.status == 200) {
                console.log(responseData)
                if (responseData.result != null) {
                    this.helpValue = responseData.result.documentData
                } else {
                    this.helpValue = ''
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 保存编辑内容
        async saveOrUpdate() {
            if (this.jurId == '') {
                return this.$message({
                    message: '请先选择功能',
                    type: 'warning'
                });
            }
            let params = {
                jurId: this.jurId,
                documentData: this.helpValue
            }
            var responseData = await this.$http.saveOrUpdate(params)
            if (responseData.status == 200) {
                console.log(responseData)
                this.$message({
                    message: responseData.message,
                    type: 'success'
                });
                // this.helpValue = responseData.result ? 
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getJurisdictionList()
        this.$nextTick(()=>{
            this.boxHeight = document.documentElement.clientHeight - 180 + 'px';
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

.myquillEditor {
    width: 100% !important;
}

::v-deep #punContent {
    width: 100% !important;
}
</style>
